import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { DocumentTemplateEditItemImageComponent } from './edit-item/image/image.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { DocumentTemplateService } from './document-template.service';
import { DocumentTemplateListViewComponent } from './document-template-list-view/document-template-list-view.component';
import { DocumentTemplateListComponent } from './document-template-list/document-template-list.component';
import { FiDocumentTemplateEditBasicComponent } from './document-template-edit-basic/document-template-edit-basic.component';
import { FiDocumentTemplateEditGeneralComponent } from './document-template-edit-general/document-template-edit-general.component';
import { FormsModule } from '@angular/forms';
import { DndModule } from 'ngx-drag-drop';
import { FiDocumentTemplateModelsListComponent } from './document-template-models-list/document-template-models-list.component';
import { FiDocumentTemplateItemViewComponent } from './document-template-item-view/document-template-item-view.component';
import { FiDocumentTemplateItemViewSimpleTextComponent } from './document-template-item-view/document-template-item-view-simple-text.component';
import { FiDocumentTemplateItemViewAdvancedTextComponent } from './document-template-item-view/document-template-item-view-advanced-text.component';
import { FiDocumentTemplateItemViewImageComponent } from './document-template-item-view/document-template-item-view-image.component';
import { FiDocumentTemplateItemViewSiteMapComponent } from './document-template-item-view/document-template-item-view-site-map.component';
import { FiDocumentLayoutModule } from '@fi-app/document/document-layout/document-layout.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { FiDocumentTemplateColumnSettingsComponent } from './document-template-column-settings/document-template-column-settings.component';
import { FiDocumentTemplateLockSettingsComponent } from './document-template-lock-settings/document-template-lock-settings.component';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { FiReplaceWithLinksModule } from '@fi-app/shared/fi-directives/replace-with-links/replace-with-links.module';
import { WidgetSettingsModule } from '@fi-app/widget-settings/widget-settings.module';
import { FiDocumentTemplateItemOptionsComponent } from './document-template-item-options/document-template-item-options.component';
import { FiDocumentTemplateItemOptionsColumnComponent } from './document-template-item-options/document-template-item-options-column.component';
import { FiDocumentTemplateItemOptionsSimpleTextComponent } from './document-template-item-options/document-template-item-options-simple-text/document-template-item-options-simple-text.component';
import { FiDocumentTemplateItemOptionsAdvancedTextComponent } from './document-template-item-options/document-template-item-options-advanced-text/document-template-item-options-advanced-text.component';
import { FiDocumentTemplateItemOptionsSiteMapComponent } from './document-template-item-options/document-template-item-options-site-map/document-template-item-options-site-map.component';
import { FiDocumentTemplateItemOptionsImageComponent } from './document-template-item-options/document-template-item-options-image/document-template-item-options-image.component';
import { FiDocumentTemplateLayoutViewComponent } from '@fi-app/document-template/document-template-layout-view/document-template-layout-view.component';
import { FiDocumentTemplateViewComponent } from '@fi-app/document-template/document-template-view/document-template-view.component';
import { FiDocumentTemplateLayoutEditComponent } from '@fi-app/document-template/document-template-layout-edit/document-template-layout-edit.component';
import { FiDocumentTemplateOptionsService } from '@fi-app/document-template/document-template-options.service';
import { FiDocumentTemplateLayoutTrashBinService } from '@fi-app/document-template/document-template-layout-trash-bin.service';
import { FiDocumentTemplateTrashBinComponent } from '@fi-app/document-template/document-template-trash-bin/document-template-trash-bin.component';
import { FiDocumentTemplateEditLayoutComponent } from '@fi-app/document-template/document-template-edit-layout/document-template-edit-layout.component';
import { FiDocumentTemplateEditComponent } from '@fi-app/document-template/document-template-edit/document-template-edit.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiDocumentTemplateStates } from '@fi-app/document-template/document-template-states';
import { DocumentTemplateConfirmDeleteDialogComponent } from './document-template-confirm-delete-dialog/document-template-confirm-delete-dialog.component';
import { DocumentTemplateConfirmDeleteViewRowComponent } from './document-template-confirm-delete-dialog/document-template-confirm-delete-view-row/document-template-confirm-delete-view-row.component';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { FiWrapperTableModule } from '@fi-app/shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiLocalSearch2Module } from '@fi-app/shared/fi-local-search2/fi-local-search2.module';
import { FiSideListNewModule } from '@fi-app/utilities/side-list-new/side-list-new.module';
import { DocumentUsageListComponent } from './document-template-confirm-delete-dialog/document-usage-list/document-usage-list.component';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        ComponentsModule,
        FormsModule,
        DndModule,
        MatTabsModule,
        MatRadioModule,
        MatCheckboxModule,
        FiDocumentLayoutModule,
        FiAutofocusModule,
        FiReplaceWithLinksModule,
        FiVimeoModule,
        WidgetSettingsModule,
        UIRouterModule.forChild(FiDocumentTemplateStates),
        FiItemsListModule,
        MatIconModule,
        MatButtonModule,
        FiPageHeaderModule,
        SelectSearchModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        FiWrapperTableModule,
        FiLocalSearch2Module,
        FiSideListNewModule,
        FiNameInputModule,
    ],
    declarations: [
        DocumentTemplateEditItemImageComponent,
        DocumentTemplateListViewComponent,
        DocumentTemplateListComponent,
        FiDocumentTemplateEditBasicComponent,
        FiDocumentTemplateEditGeneralComponent,
        FiDocumentTemplateModelsListComponent,
        FiDocumentTemplateItemViewComponent,
        FiDocumentTemplateItemViewSimpleTextComponent,
        FiDocumentTemplateItemViewAdvancedTextComponent,
        FiDocumentTemplateItemViewImageComponent,
        FiDocumentTemplateItemViewSiteMapComponent,
        FiDocumentTemplateItemOptionsComponent,
        FiDocumentTemplateItemOptionsColumnComponent,
        FiDocumentTemplateColumnSettingsComponent,
        FiDocumentTemplateLockSettingsComponent,
        FiDocumentTemplateItemOptionsSimpleTextComponent,
        FiDocumentTemplateItemOptionsAdvancedTextComponent,
        FiDocumentTemplateItemOptionsSiteMapComponent,
        FiDocumentTemplateItemOptionsImageComponent,
        FiDocumentTemplateLayoutViewComponent,
        FiDocumentTemplateViewComponent,
        FiDocumentTemplateLayoutEditComponent,
        FiDocumentTemplateTrashBinComponent,
        FiDocumentTemplateEditLayoutComponent,
        FiDocumentTemplateEditComponent,
        DocumentTemplateConfirmDeleteDialogComponent,
        DocumentTemplateConfirmDeleteViewRowComponent,
        DocumentUsageListComponent,
    ],
    exports: [DocumentTemplateEditItemImageComponent],
    providers: [DocumentTemplateService, FiDocumentTemplateOptionsService, FiDocumentTemplateLayoutTrashBinService],
})
export class DocumentTemplateModule {}
